fx.ns("common.popups", class MagicPlacement extends shared.popups.BasePersonPopup{
    
    constructor(data)
    {
        super(data, fx.get("assets").personSure );

        this.contentWidth = 670;
        this.contentHeight = this.data.creation.hasContent ? 265 : 225;
    }

    create()
    {
        super.create();

        this.title = new fx.components.Text({text:fx.text("Souhaitez-vous que je crée votre album photo ?"), className:"title center"});
        this.text = new fx.components.Text({text:fx.text("Vos photos seront placées par ordre chronologique,<br>et vous n'aurez plus qu'à vérifier votre album."), className:"text center"});
        
        
        this.addChild(this.title);
        this.addChild(this.text);

        if (this.data.creation.hasContent)
        {
            this.warningText = new fx.components.Text({text:fx.text("Attention : votre contenu sera totalement remplacé."), className:"text center pink bold"});
            this.addChild( this.warningText );
        }


        this.okButton = new fx.components.Button({label : fx.text("Oui, Créez mon album"), type : "filled"});
        this.cancelButton = new fx.components.Button({label : fx.text("Non, merci")});
        
        this.addFooterChild(this.cancelButton, {width : 180});
        this.addFooterChild(this.okButton, {width : 280});
    }

    onReady()
    {
        super.onReady();

        this.on("click", this.onMagic, this.okButton);
        this.on("click", this.onClose, this.cancelButton);
    }

    onMagic()
    {
        if (this.data.photos.extracting)
            this._switchWaiting();
        else
            this._placePhotos()
    }

    _switchWaiting()
    {
        this._switchedWaiting = true;
        this.title.text = fx.text("Un instant, je place vos photos...");
        this.text.destroy();
        if (this.warningText)
            this.warningText.destroy();

        let hbox = new fx.components.Box();
        hbox.addChild(new fx.components.Image(fx.assets.loader), {width : 50, height : 50, left : "center", top : "center"});
        this.addChild(hbox, {width : "100%", height : "160"});


        this.cancelButton.hide();
        this.okButton.hide();
    }

    _placePhotos()
    {
        this.data.placePhotosChronologically( this.data.photos.active );
        this.onClose();
    }

    onDataEvent(event)
    {
        if (event.type == "photo-extracted-updated" && this._switchedWaiting)
        {
            if (!this.data.photos.extracting)
                this._placePhotos();
        }
    }

});
